// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3X0Dh","colMin":"styles_colMin__7j0rD"};